import React from "react";
import "../../styles/TopProviders.css";

const TopProviders = ({ providers = [] }) => {
    return (
        <div className="report-card">

            <div className="card-header">
                <h3>Top Providers</h3>
            </div>

            <div className="table-responsive">

                <table className="report-table">

                    <thead>

                        <tr>
                            <th>Provider</th>
                            <th>Orders</th>
                            <th>Revenue</th>
                            <th>Rating</th>
                        </tr>

                    </thead>

                    <tbody>

                        {providers.length === 0 ? (

                            <tr>
                                <td colSpan="4">
                                    No Providers Found
                                </td>
                            </tr>

                        ) : (

                            providers.map((provider) => (

                                <tr key={provider._id}>

                                    <td>{provider.businessName}</td>

                                    <td>{provider.orders}</td>

                                    <td>₹{provider.revenue}</td>

                                    <td>{provider.rating}</td>

                                </tr>

                            ))

                        )}

                    </tbody>

                </table>

            </div>

        </div>
    );
};

export default TopProviders;